<div class="med" [class.med-v]="verticale" [class.med-drag]="inTrascinamentoAttivo" (pointerdown)="premi($event)">
	<!-- La barra del menu, com'e' nel portale: voci e menu da trascinare -->
	<ul class="med-barra" #barra (scroll)="riposiziona()" role="menubar" [attr.aria-label]="'Menu in modifica' | translate">
		@for (n of svc.albero; track n.uid; let i = $index) {
			<li class="med-top" [attr.data-med-bar]="i" [class.med-ins-prima]="insBarra(i, true)" [class.med-ins-dopo]="insBarra(i, false)">
				<button type="button" class="med-piu" (click)="apriInseritore(null, i, $event)" [pTooltip]="'Inserisci qui' | translate" tooltipPosition="bottom" [attr.aria-label]="'Inserisci prima di' | translate"><i class="pi pi-plus"></i></button>
				<div
					class="med-btn"
					role="menuitem"
					tabindex="0"
					[attr.data-med-drag]="n.uid"
					[attr.data-med-menu-btn]="n.tipo === 'menu' ? n.uid : null"
					[attr.aria-expanded]="n.tipo === 'menu' ? isAperto(n) : null"
					[class.med-aperto]="isAperto(n)"
					[class.med-dentro]="dentro(n.uid)"
					[class.med-spento]="svc.nascostaAlRuolo(n)"
					[class.med-sorgente]="inTrascinamento(n.uid)"
					(click)="clicVoce(n, $event)"
					(keydown.enter)="$event.target === $event.currentTarget && n.tipo === 'menu' && apriChiudi(n.uid)"
					(dblclick)="avviaRinomina(n, $event)"
				>
					<button type="button" class="med-ico" (click)="apriIcone(n, $event)" [pTooltip]="'Cambia icona' | translate" tooltipPosition="bottom" [attr.aria-label]="'Cambia icona' | translate"><i [class]="svc.icona(n)"></i></button>
					@if (rinominaUid === n.uid) {
						<input class="med-input" [(ngModel)]="rinominaValore" (keydown.enter)="confermaRinomina()" (keydown.escape)="annullaRinomina()" (blur)="confermaRinomina()" (click)="$event.stopPropagation()" [attr.aria-label]="'Nome' | translate" />
					} @else {
						<span class="med-label">{{ svc.titolo(n) | translate }}</span>
					}
					<i class="med-tipo {{ tipo(n, 0).icon }}" [pTooltip]="tipo(n, 0).testo | translate" tooltipPosition="bottom" [attr.aria-label]="tipo(n, 0).testo | translate"></i>
					@if (svc.inScheda(n); as sezione) {
						<i class="pi pi-clone med-badge" [pTooltip]="('Con la sezione a schede attiva questa voce sta nelle schede di' | translate) + ' ' + (sezione | translate)" tooltipPosition="bottom"></i>
					}
					@if (svc.nascostaAlRuolo(n)) {
						<i class="pi pi-eye-slash med-badge" [pTooltip]="'Questo ruolo non la vede' | translate" tooltipPosition="bottom"></i>
					}
					@if (n.tipo === 'menu') {
						<i class="pi med-caret" [class.pi-angle-down]="!isAperto(n)" [class.pi-angle-up]="isAperto(n)" aria-hidden="true"></i>
					} @else if (n.tipo === 'collegamento') {
						<button type="button" class="med-act" (click)="svc.rimuovi(n.uid)" [pTooltip]="'Togli dal menu' | translate" [attr.aria-label]="'Togli dal menu' | translate"><i class="pi pi-times"></i></button>
					} @else {
						<button type="button" class="med-act" (click)="$event.stopPropagation(); svc.nascondi(n.uid)" [pTooltip]="'Togli dal menu: la pagina resta raggiungibile e si rimette da Collegamenti > Pagine nascoste' | translate" tooltipPosition="bottom" [attr.aria-label]="'Togli dal menu' | translate"><i class="pi pi-times"></i></button>
					}
				</div>
				@if (verticale && n.tipo === 'menu' && isAperto(n)) {
					<div class="med-tendina-v">
						<ng-container [ngTemplateOutlet]="tendina" [ngTemplateOutletContext]="{ menu: n, livello: 1 }"></ng-container>
					</div>
				}
			</li>
		}
		<li class="med-fine" data-med-bar-end>
			<button type="button" class="med-nuovo" (click)="apriInseritore(null, svc.albero.length, $event)" [pTooltip]="'Aggiungi in fondo' | translate" [attr.aria-label]="'Aggiungi in fondo' | translate"><i class="pi pi-plus"></i></button>
		</li>
	</ul>

	<!-- Menu aperto (sotto la voce) e suo sottomenu aperto (di lato), come in Word -->
	@if (!verticale && menuAperto; as menu) {
		<div class="med-tendina" [class.med-ribbon]="ribbon" [class.med-ribbon-blocchi]="ribbonBlocchi" [class.med-con-palette]="paletteAperta" [style.top.px]="posTendina.top" [style.left.px]="posTendina.left" (scroll)="riposizionaSub()">
			<ng-container [ngTemplateOutlet]="tendina" [ngTemplateOutletContext]="{ menu: menu, livello: 1 }"></ng-container>
		</div>
		@if (!ribbonBlocchi && subAperto; as sub) {
			<div class="med-tendina med-flyout" [class.med-flyout-sotto]="ribbon" [style.top.px]="posSub.top" [style.left.px]="posSub.left">
				<ng-container [ngTemplateOutlet]="tendina" [ngTemplateOutletContext]="{ menu: sub, livello: 2 }"></ng-container>
			</div>
		}
	}

	<!-- Contenuto di un menu (livello 1) o di un sottomenu (livello 2): intestazione e voci -->
	<ng-template #tendina let-menu="menu" let-livello="livello">
		<div class="med-dd-head" [attr.data-med-menu]="menu.uid">
			<button type="button" class="med-act med-icona" (click)="apriIcone(menu, $event)" [pTooltip]="'Cambia icona' | translate" [attr.aria-label]="'Cambia icona' | translate"><i [class]="menu.icon"></i></button>
			<!-- nella sidebar il nome e' gia' sulla voce, sopra -->
			<span class="med-dd-titolo" (dblclick)="avviaRinomina(menu, $event)">{{ verticale || (ribbonBlocchi && livello === 2) ? '' : (menu.label | translate) }}</span>
			<button type="button" class="med-act" (click)="avviaRinomina(menu, $event)" [pTooltip]="'Rinomina' | translate" [attr.aria-label]="'Rinomina' | translate"><i class="pi pi-pencil"></i></button>
			@if (eliminando === menu.uid) {
				<span class="med-elimina">
					<button type="button" class="med-aggiungi" (click)="$event.stopPropagation(); eliminaGruppo($any(menu))" [pTooltip]="'Le voci restano al posto del gruppo' | translate">{{ 'Solo il gruppo' | translate }}</button>
					<button type="button" class="med-aggiungi med-act-danger" (click)="$event.stopPropagation(); eliminaGruppo($any(menu), true)" [pTooltip]="'Le pagine vanno tra le nascoste, i collegamenti si tolgono' | translate">{{ 'Gruppo e voci' | translate }}</button>
					<button type="button" class="med-act" (click)="$event.stopPropagation(); eliminando = null" [attr.aria-label]="'Annulla' | translate"><i class="pi pi-times"></i></button>
				</span>
			} @else {
				<button type="button" class="med-act med-act-danger" (click)="eliminando = menu.uid" [pTooltip]="(livello === 1 ? 'Elimina il gruppo' : 'Elimina il sottogruppo') | translate" [attr.aria-label]="'Elimina' | translate"><i class="pi pi-trash"></i></button>
			}
		</div>
		<ul class="med-dd-lista" role="menu">
			@for (v of menu.voci; track v.uid; let j = $index) {
				<li
					class="med-riga"
					role="menuitem"
					[attr.data-med-dd]="j"
					[attr.data-med-menu]="menu.uid"
					[attr.data-med-drag]="v.uid"
					[attr.aria-haspopup]="v.tipo === 'menu' ? 'menu' : null"
					[class.med-sottomenu]="v.tipo === 'menu'"
					[class.med-ins-prima]="insRiga(menu.uid, j, true)"
					[class.med-ins-dopo]="insRiga(menu.uid, j, false)"
				>
					<button type="button" class="med-piu" (click)="apriInseritore(menu.uid, j, $event)" [pTooltip]="'Inserisci qui' | translate" tooltipPosition="left" [attr.aria-label]="'Inserisci prima di' | translate"><i class="pi pi-plus"></i></button>
					<div
						class="med-riga-testa"
						[class.med-aperto]="v.tipo === 'menu' && isAperto(v)"
						[class.med-dentro]="dentro(v.uid)"
						[class.med-spento]="svc.nascostaAlRuolo(v)"
						[class.med-sorgente]="inTrascinamento(v.uid)"
						(click)="clicRiga(v, $event)"
						(dblclick)="avviaRinomina(v, $event)"
					>
						<i class="pi pi-bars med-grip" aria-hidden="true"></i>
						<button type="button" class="med-ico" (click)="apriIcone(v, $event)" [pTooltip]="'Cambia icona' | translate" tooltipPosition="right" [attr.aria-label]="'Cambia icona' | translate"><i [class]="svc.icona(v)"></i></button>
						@if (rinominaUid === v.uid) {
							<input class="med-input" [(ngModel)]="rinominaValore" (keydown.enter)="confermaRinomina()" (keydown.escape)="annullaRinomina()" (blur)="confermaRinomina()" (click)="$event.stopPropagation()" [attr.aria-label]="'Nome' | translate" />
						} @else {
							<span class="med-label">{{ svc.titolo(v) | translate }}</span>
						}
						<i class="med-tipo {{ tipo(v, livello).icon }}" [pTooltip]="tipo(v, livello).testo | translate" tooltipPosition="right" [attr.aria-label]="tipo(v, livello).testo | translate"></i>
						@if (svc.inScheda(v); as sezione) {
							<i class="pi pi-clone med-badge" [pTooltip]="('Con la sezione a schede attiva questa voce sta nelle schede di' | translate) + ' ' + (sezione | translate)" tooltipPosition="right"></i>
						}
						@if (svc.nascostaAlRuolo(v)) {
							<i class="pi pi-eye-slash med-badge" [pTooltip]="'Questo ruolo non la vede' | translate" tooltipPosition="right"></i>
						}
						@if (v.tipo === 'pagina') {
							<button type="button" class="med-act" (click)="avviaRinomina(v, $event)" [pTooltip]="'Rinomina (vuoto = nome della pagina)' | translate" [attr.aria-label]="'Rinomina' | translate"><i class="pi pi-pencil"></i></button>
							<button type="button" class="med-act med-act-danger" (click)="$event.stopPropagation(); svc.nascondi(v.uid)" [pTooltip]="'Togli dal menu: la pagina resta raggiungibile e si rimette da Collegamenti > Pagine nascoste' | translate" tooltipPosition="right" [attr.aria-label]="'Togli dal menu' | translate"><i class="pi pi-times"></i></button>
						} @else if (v.tipo === 'collegamento') {
							<button type="button" class="med-act med-act-danger" (click)="svc.rimuovi(v.uid)" [pTooltip]="'Togli dal menu' | translate" [attr.aria-label]="'Togli dal menu' | translate"><i class="pi pi-times"></i></button>
						} @else {
							@if (!ribbonBlocchi) {
								<!-- nella barra come Word il sottogruppo si apre sotto (freccia giu'), nella tendina di lato -->
								<i class="pi med-caret" [class.pi-angle-right]="!verticale && !ribbon" [class.pi-angle-down]="(verticale || ribbon) && !isAperto(v)" [class.pi-angle-up]="(verticale || ribbon) && isAperto(v)" aria-hidden="true"></i>
							} @else {
								<!-- barra come Word: le azioni del sottogruppo stanno sulla sua intestazione -->
								<button type="button" class="med-act" (click)="apriIcone(v, $event)" [pTooltip]="'Cambia icona' | translate" [attr.aria-label]="'Cambia icona' | translate"><i class="pi pi-image"></i></button>
								<button type="button" class="med-act" (click)="avviaRinomina(v, $event)" [pTooltip]="'Rinomina' | translate" [attr.aria-label]="'Rinomina' | translate"><i class="pi pi-pencil"></i></button>
								@if (eliminando === v.uid) {
				<span class="med-elimina">
					<button type="button" class="med-aggiungi" (click)="$event.stopPropagation(); eliminaGruppo($any(v))" [pTooltip]="'Le voci restano al posto del gruppo' | translate">{{ 'Solo il gruppo' | translate }}</button>
					<button type="button" class="med-aggiungi med-act-danger" (click)="$event.stopPropagation(); eliminaGruppo($any(v), true)" [pTooltip]="'Le pagine vanno tra le nascoste, i collegamenti si tolgono' | translate">{{ 'Gruppo e voci' | translate }}</button>
					<button type="button" class="med-act" (click)="$event.stopPropagation(); eliminando = null" [attr.aria-label]="'Annulla' | translate"><i class="pi pi-times"></i></button>
				</span>
			} @else {
									<button type="button" class="med-act med-act-danger" (click)="$event.stopPropagation(); eliminando = v.uid" [pTooltip]="'Elimina il sottogruppo' | translate" [attr.aria-label]="'Elimina' | translate"><i class="pi pi-trash"></i></button>
								}
							}
						}
					</div>
					@if (v.tipo === 'menu' && (ribbonBlocchi || (verticale && isAperto(v)))) {
						<div class="med-tendina-v">
							<ng-container [ngTemplateOutlet]="tendina" [ngTemplateOutletContext]="{ menu: v, livello: 2 }"></ng-container>
						</div>
					}
				</li>
			}
			<li class="med-riga-fine" data-med-dd-end [attr.data-med-menu]="menu.uid" [class.med-dentro]="dentro(menu.uid)">
				<button type="button" class="med-aggiungi" (click)="apriInseritore(menu.uid, menu.voci.length, $event)"><i class="pi pi-plus"></i> {{ 'Aggiungi' | translate }}</button>
				@if (!menu.voci.length) {
					<span>{{ 'oppure trascina qui le voci' | translate }}</span>
				}
			</li>
		</ul>
	</ng-template>

	<!-- Scelta dell'icona di una voce: tutte le PrimeIcons, con ricerca per nome -->
	@if (iconeDi && nodoIcone; as nodo) {
		<div class="med-icone-pop" [style.top.px]="iconeDi.top" [style.left.px]="iconeDi.left" role="dialog" [attr.aria-label]="'Cambia icona' | translate">
			<div class="med-ins-head">
				<strong><i [class]="svc.icona(nodo)"></i> {{ svc.titolo(nodo) | translate }}</strong>
				<button type="button" class="med-act" (click)="iconeDi = null" [attr.aria-label]="'Chiudi' | translate"><i class="pi pi-times"></i></button>
			</div>
			<input class="kcs-inputtext kcs-component w-100" [(ngModel)]="cercaIcona" [placeholder]="'Cerca icona (in inglese: home, user, chart...)' | translate" (keydown.escape)="iconeDi = null" />
			@if (nodo.tipo !== 'menu' && svc.icona(nodo) !== svc.iconaOriginale(nodo)) {
				<button type="button" class="med-aggiungi" (click)="scegliIcona(svc.iconaOriginale(nodo))"><i [class]="svc.iconaOriginale(nodo)"></i> {{ (nodo.tipo === 'pagina' ? 'Icona della pagina' : 'Icona del collegamento') | translate }}</button>
			}
			<div class="med-icons">
				@for (ic of iconeFiltrate(); track ic) {
					<button type="button" [class.med-icona-scelta]="ic === svc.icona(nodo)" (click)="scegliIcona(ic)" [pTooltip]="ic.slice(6)" tooltipPosition="top" [attr.aria-label]="ic.slice(6)"><i [class]="ic"></i></button>
				} @empty {
					<small class="med-imp-nota">{{ 'Nessuna icona con questo nome' | translate }}</small>
				}
			</div>
		</div>
	}

	<!-- Inserisci qui: menu/sottomenu nuovo, una pagina (spostata qui) o un collegamento -->
	@if (inseritore; as ins) {
		<div class="med-ins-pop" [style.top.px]="ins.top" [style.left.px]="ins.left" role="dialog" [attr.aria-label]="'Inserisci qui' | translate">
			<div class="med-ins-head">
				<strong>{{ 'Inserisci in' | translate }} {{ doveInserisco | translate }}</strong>
				<button type="button" class="med-act" (click)="chiudiInseritore()" [attr.aria-label]="'Chiudi' | translate"><i class="pi pi-times"></i></button>
			</div>
			@if (svc.puoStare('gruppo', ins.menu)) {
				<button type="button" class="med-ins-voce" (click)="inserisciGruppo()">
					<i [class]="ins.menu == null ? 'pi pi-folder-open' : 'pi pi-sitemap'"></i>
					<span>
						<strong>{{ (ins.menu == null ? 'Nuovo gruppo' : 'Nuovo sottogruppo') | translate }}</strong>
						<small>{{ (ins.menu == null ? 'Una voce della barra che raccoglie altre voci: non e\' una pagina' : 'Un gruppo dentro il gruppo: non e\' una pagina' ) | translate }}</small>
					</span>
				</button>
			}
			<button type="button" class="med-ins-voce" [class.med-ins-scelta]="ins.scelta === 'pagina'" (click)="ins.scelta = 'pagina'">
				<i class="pi pi-file"></i>
				<span>
					<strong>{{ 'Pagina' | translate }}</strong>
					<small>{{ 'Cerca per nome o indirizzo tra pagine, cruscotti e collegamenti: se sono gia nel menu vengono spostati qui' | translate }}</small>
				</span>
			</button>
			@if (ins.scelta === 'pagina') {
				<p-select [options]="opzioniPagine" optionLabel="label" optionValue="value" [filter]="true" filterBy="cerca" appendTo="body" [style]="{ width: '100%' }" [placeholder]="'Scegli la pagina' | translate" (onChange)="inserisciPagina($event.value)">
					<ng-template #item let-o>
						<span class="med-opzione"><span>{{ o.label }}</span><small>{{ o.url }}</small></span>
					</ng-template>
				</p-select>
			}
			<button type="button" class="med-ins-voce" [class.med-ins-scelta]="ins.scelta === 'collegamento'" (click)="ins.scelta = 'collegamento'" [disabled]="!opzioniCollegamenti.length">
				<i class="pi pi-link"></i>
				<span>
					<strong>{{ 'Collegamento' | translate }}</strong>
					<small>{{ 'Una sezione di una pagina, come le card (es. HR > Dipendenti)' | translate }}</small>
				</span>
			</button>
			@if (ins.scelta === 'collegamento') {
				<p-select [options]="opzioniCollegamenti" [group]="true" optionLabel="label" optionValue="value" optionGroupLabel="label" optionGroupChildren="items" [filter]="true" filterBy="label" appendTo="body" [style]="{ width: '100%' }" [placeholder]="'Scegli il collegamento' | translate" (onChange)="inserisciCollegamento($event.value)"></p-select>
			}
		</div>
	}

	<!-- Collegamenti alle sezioni delle pagine (come le card), da trascinare nel menu -->
	@if (paletteAperta) {
		<aside class="med-palette" data-med-palette [class.med-cestino]="cestino" [attr.aria-label]="'Collegamenti' | translate">
			<div class="med-palette-head">
				<strong>{{ 'Aggiungi al menu' | translate }}</strong>
				<button type="button" class="med-act" (click)="paletteAperta = false; riposiziona()" [attr.aria-label]="'Chiudi' | translate"><i class="pi pi-times"></i></button>
			</div>
			<div class="med-palette-nuovo" data-med-nuovo="menu" (click)="nuovoMenu()" [pTooltip]="'Sulla barra diventa un gruppo, dentro un gruppo un sottogruppo' | translate" tooltipPosition="left"><i class="pi pi-bars med-grip"></i><i class="pi pi-folder"></i> {{ 'Nuovo gruppo o sottogruppo' | translate }}</div>
			@if (svc.nascoste.size) {
				<div class="med-palette-gruppo">{{ 'Pagine nascoste' | translate }}</div>
				@for (p of svc.statoNascoste(); track p.pg_id) {
					<div class="med-palette-voce" [attr.data-med-nuovo]="'pg:' + p.pg_id" (click)="ripristinaDaPalette(p.pg_id)" [pTooltip]="'Trascinala nel menu o clic per rimetterla nel gruppo aperto' | translate" tooltipPosition="left"><i class="pi pi-bars med-grip"></i><i [class]="p.icona"></i> {{ p.titolo | translate }}
						@if (p.via) {
							<i class="pi pi-check-circle ms-auto med-ok" [pTooltip]="('Si raggiunge comunque: ' | translate) + (p.via | translate)" tooltipPosition="left"></i>
						} @else {
							<i class="pi pi-exclamation-triangle ms-auto med-warn" [pTooltip]="'Non si raggiunge dal menu' | translate" tooltipPosition="left"></i>
						}</div>
				}
				<div class="med-palette-gruppo">{{ 'Collegamenti' | translate }}</div>
			}
			<input class="kcs-inputtext kcs-component w-100 mb-2" [(ngModel)]="cercaCollegamento" [placeholder]="'Cerca collegamento' | translate" />
			<div class="med-palette-lista">
				@for (g of gruppiCollegamenti(); track g.gruppo) {
					<div class="med-palette-gruppo">{{ g.gruppo | translate }}</div>
					@for (sc of g.voci; track sc.key) {
						@if (svc.collegamentiUsati().has(sc.key)) {
							<div class="med-palette-voce med-usata" [pTooltip]="'Gia nel menu' | translate" tooltipPosition="left"><i [class]="sc.icon"></i> {{ sc.labelKey | translate }} <i class="pi pi-check ms-auto"></i></div>
						} @else {
							<div class="med-palette-voce" [attr.data-med-nuovo]="'sc:' + sc.key" (click)="aggiungiDaPalette(sc)"><i class="pi pi-bars med-grip"></i><i [class]="sc.icon"></i> {{ sc.labelKey | translate }}</div>
						}
					}
				}
			</div>
			<small class="med-palette-hint">{{ (cestino ? 'Rilascia per togliere la voce dal menu' : 'Trascina nel menu, oppure clic per aggiungere al gruppo aperto. Trascina qui una voce per toglierla dal menu.') | translate }}</small>
		</aside>
	}

	<!-- Mappa del menu: albero per il ruolo di "Vedi come", da stampare -->
	<p-dialog [(visible)]="mappaAperta" [modal]="true" [header]="'Mappa del menu' | translate" [style]="{ width: '680px', maxWidth: '95vw' }" [baseZIndex]="2000" appendTo="body" [draggable]="false" [dismissableMask]="true">
		<div class="med-mappa-filtro">
			@if (!svc.senzaRuoli) {
				<label class="kcs-form-label mb-0">{{ 'Ruolo' | translate }}</label>
				<p-select [options]="opzioniRuolo" optionLabel="label" optionValue="value" [(ngModel)]="svc.ruolo" (onChange)="apriMappa()" [filter]="svc.ruoli.length > 8" appendTo="body" [style]="{ width: '260px' }"></p-select>
			}
			<small class="med-mappa-conta">{{ contaMappa.menu }} {{ 'gruppi e sottogruppi' | translate }} · {{ contaMappa.pagine }} {{ 'pagine' | translate }} · {{ contaMappa.collegamenti }} {{ 'collegamenti' | translate }}</small>
		</div>
		@if (svc.modificato) {
			<small class="med-mappa-bozza"><i class="pi pi-info-circle"></i> {{ 'Mappa della bozza: le modifiche non sono ancora salvate.' | translate }}</small>
		}
		<div class="med-mappa">
			@if (righeMappa.length) {
				<ng-container [ngTemplateOutlet]="nodiMappa" [ngTemplateOutletContext]="{ righe: righeMappa }"></ng-container>
			} @else {
				<small>{{ 'Questo ruolo non vede nessuna voce del menu.' | translate }}</small>
			}
		</div>
		<ng-template #nodiMappa let-righe="righe">
			<ul>
				@for (r of righe; track $index) {
					<li [class]="'med-mappa-' + r.tipo">
						<span class="med-mappa-riga">
							<i [class]="r.icona" aria-hidden="true"></i>
							<span class="med-mappa-titolo">{{ r.titolo | translate }}</span>
							<span class="med-mappa-tipo">{{ tipoMappa(r) | translate }}</span>
							@if (r.url) {
								<span class="med-mappa-url">{{ r.url }}</span>
							}
							@if (r.scheda) {
								<span class="med-mappa-scheda">{{ 'nelle schede di' | translate }} {{ r.scheda | translate }}</span>
							}
						</span>
						@if (r.figli.length) {
							<ng-container [ngTemplateOutlet]="nodiMappa" [ngTemplateOutletContext]="{ righe: r.figli }"></ng-container>
						}
					</li>
				}
			</ul>
		</ng-template>
		<ng-template #footer>
			<div class="d-flex justify-content-end gap-2">
				<p-button [label]="'Chiudi' | translate" size="small" severity="secondary" [outlined]="true" (onClick)="mappaAperta = false"></p-button>
				<p-button [label]="'Stampa' | translate" size="small" severity="primary" icon="pi pi-print" [disabled]="!righeMappa.length" (onClick)="stampaMappa()"></p-button>
			</div>
		</ng-template>
	</p-dialog>

	<!-- Pagine dell'azienda che con questo menu non si raggiungono (ne' dal menu ne' da collegamenti o schede) -->
	@if (avvisiAperti && svc.pagineIrraggiungibili().length) {
		<aside class="med-impostazioni med-avvisi" [attr.aria-label]="'Pagine non raggiungibili' | translate">
			<div class="med-palette-head">
				<strong><i class="pi pi-exclamation-triangle med-warn"></i> {{ 'Pagine non raggiungibili dal menu' | translate }}</strong>
				<button type="button" class="med-act" (click)="avvisiAperti = false" [attr.aria-label]="'Chiudi' | translate"><i class="pi pi-times"></i></button>
			</div>
			<small class="med-imp-nota d-block mb-2">{{ "L'azienda ha queste pagine (servizi e ruoli) ma con questo menu non si aprono da nessuna voce: ne' dal menu, ne' da un collegamento, ne' dalle schede di una sezione. Rimettile, oppure salva comunque se e' voluto." | translate }}</small>
			@for (p of svc.pagineIrraggiungibili(); track p.pg_id) {
				<div class="med-avviso-riga">
					<i [class]="p.icona"></i>
					<span class="med-avviso-testo">
						<strong>{{ p.titolo | translate }}</strong>
						<small>{{ p.url }}@if (p.ruoli.length) { · {{ 'la vedono' | translate }}: {{ p.ruoli.join(', ') }}}</small>
						@if (p.perse.length) {
							<!-- pagine che si aprivano solo dalle card di questa pagina -->
							<small>{{ 'Con lei non si aprono neanche' | translate }}: {{ nomiCollegamenti(p.perse) }}</small>
						}
					</span>
					<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-undo" [label]="'Rimetti nel menu' | translate" (onClick)="rimettiPagina(p.pg_id)"></p-button>
				</div>
				@if (p.perse.length) {
					<div class="d-flex justify-content-end mb-2">
						<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-plus" [label]="'Aggiungi solo queste al menu' | translate" [pTooltip]="'Le aggiunge come collegamenti in fondo al gruppo aperto (o alla barra); la pagina resta fuori dal menu' | translate" tooltipPosition="left" (onClick)="aggiungiPerse(p.perse)"></p-button>
					</div>
				}
			}
		</aside>
	}

	<!-- Impostazioni menu: le stesse dell'anagrafica azienda, applicate con Salva (la posizione si vede subito) -->
	@if (impostazioniAperte) {
		<aside class="med-impostazioni" [attr.aria-label]="'Impostazioni menu' | translate">
			<div class="med-palette-head">
				<strong>{{ 'Impostazioni menu' | translate }}</strong>
				<button type="button" class="med-act" (click)="impostazioniAperte = false" [attr.aria-label]="'Chiudi' | translate"><i class="pi pi-times"></i></button>
			</div>

			<h6>{{ "Menu dell'azienda" | translate }}</h6>
			<div class="med-imp-riga">
				<div class="med-imp-campo">
					<label class="kcs-form-label">{{ 'Menu da modificare' | translate }}</label>
					<p-select [options]="opzioniProfili" optionLabel="label" optionValue="value" [ngModel]="svc.profiloId || ''" (onChange)="$event.value && svc.apriProfilo($event.value)" [disabled]="svc.modificato" appendTo="body" [style]="{ width: '100%' }" [pTooltip]="svc.modificato ? ('Salva o esci senza salvare per aprire un altro menu' | translate) : ''" tooltipPosition="top"></p-select>
				</div>
				<div class="med-imp-campo">
					<label class="kcs-form-label">{{ 'Nome' | translate }}</label>
					<input class="kcs-inputtext kcs-component w-100" [ngModel]="svc.nomeProfilo" (ngModelChange)="svc.rinominaProfilo($event)" [attr.aria-label]="'Nome del menu' | translate" />
				</div>
			</div>
			<div class="med-imp-riga">
				<p-toggleswitch inputId="med-attivo" [ngModel]="svc.attivoPerAzienda" (ngModelChange)="svc.impostaAttivo($event)"></p-toggleswitch>
				<label for="med-attivo" class="mb-0">{{ "Attivo per l'azienda: è il menu che vedono tutti gli utenti" | translate }}</label>
			</div>
			<div class="med-imp-riga">
				<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-plus" [label]="'Nuovo menu' | translate" [pTooltip]="'Un menu nuovo che parte dal menu standard' | translate" tooltipPosition="top" (onClick)="svc.nuovoProfilo()"></p-button>
				<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-upload" [label]="'Importa' | translate" (onClick)="fileMenu.click()"></p-button>
				<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-download" [label]="'Esporta' | translate" [pTooltip]="'File del menu per un altro portale o ambiente (le pagine sono riconosciute per nome)' | translate" tooltipPosition="top" (onClick)="svc.esporta()"></p-button>
				<input #fileMenu type="file" hidden accept="application/json,.json" (change)="onImporta($event)" />
				@if (svc.profiloId && !confermaElimina) {
					<p-button size="small" [outlined]="true" severity="danger" icon="pi pi-trash" [label]="'Elimina menu' | translate" [disabled]="svc.modificato" [pTooltip]="(svc.modificato ? 'Salva o esci senza salvare per eliminare questo menu' : 'Elimina subito questo menu salvato') | translate" tooltipPosition="top" (onClick)="confermaElimina = true"></p-button>
				}
			</div>
			@if (svc.profiloId && confermaElimina) {
				<div class="med-imp-riga" role="alert">
					<span>{{ 'Eliminare il menu' | translate }} "{{ svc.nomeProfilo }}"?@if (svc.attivoPerAzienda) { {{ 'È quello attivo: il portale tornerà al menu standard.' | translate }} }</span>
					<p-button size="small" severity="danger" icon="pi pi-trash" [label]="'Elimina' | translate" [loading]="svc.salvataggio()" (onClick)="svc.eliminaProfilo(); confermaElimina = false"></p-button>
					<p-button size="small" [outlined]="true" severity="secondary" [label]="'Annulla' | translate" (onClick)="confermaElimina = false"></p-button>
				</div>
			}

			<h6><i class="pi pi-arrows-alt"></i> {{ 'Posizione' | translate }}</h6>
			<div class="med-imp-riga">
				<div class="med-imp-campo">
					<label class="kcs-form-label">{{ 'Dove sta il menu' | translate }}</label>
					<p-select [options]="opzioniLayout" optionLabel="label" optionValue="value" [ngModel]="svc.layout" (ngModelChange)="svc.impostaLayout($event)" appendTo="body" [style]="{ width: '100%' }">
						<ng-template #selectedItem let-o>{{ o?.label | translate }}</ng-template>
						<ng-template #item let-o>{{ o.label | translate }}</ng-template>
					</p-select>
				</div>
			</div>

			@if (svc.layout !== 'left') {
			<h6><i class="pi pi-window-maximize"></i> {{ 'Menu in alto' | translate }}</h6>
			<div class="med-imp-riga">
				<div class="med-imp-campo">
					<label class="kcs-form-label">{{ 'Clic su un gruppo' | translate }}</label>
					<p-select [options]="opzioniStile" optionLabel="label" optionValue="value" [ngModel]="svc.stile" (ngModelChange)="svc.cambiaStile($event); riposiziona()" appendTo="body" [style]="{ width: '100%' }">
						<ng-template #selectedItem let-o>{{ o?.label | translate }}</ng-template>
						<ng-template #item let-o>{{ o.label | translate }}</ng-template>
					</p-select>
				</div>
				<div class="med-imp-campo">
					<label class="kcs-form-label">{{ 'Voci che non entrano nella riga' | translate }}</label>
					<p-select [options]="opzioniACapo" optionLabel="label" optionValue="value" [ngModel]="svc.aCapo" (ngModelChange)="svc.impostaACapo($event)" appendTo="body" [style]="{ width: '100%' }">
						<ng-template #selectedItem let-o>{{ o?.label | translate }}</ng-template>
						<ng-template #item let-o>{{ o.label | translate }}</ng-template>
					</p-select>
				</div>
			</div>
			}

			@if (svc.layout !== 'left' && svc.stile === 'barra') {
			<h6><i class="pi pi-bars"></i> {{ 'Seconda barra, come Word' | translate }}</h6>
			<div class="med-imp-riga">
				<div class="med-imp-campo">
					<label class="kcs-form-label">{{ 'Voci che non entrano nella riga' | translate }}</label>
					<p-select [options]="opzioniBarraACapo" optionLabel="label" optionValue="value" [ngModel]="svc.barraACapo" (ngModelChange)="svc.impostaBarraACapo($event)" appendTo="body" [style]="{ width: '100%' }">
						<ng-template #selectedItem let-o>{{ o?.label | translate }}</ng-template>
						<ng-template #item let-o>{{ o.label | translate }}</ng-template>
					</p-select>
				</div>
				<div class="med-imp-campo">
					<label class="kcs-form-label">{{ 'Sottogruppi' | translate }}</label>
					<p-select [options]="opzioniBarraBlocchi" optionLabel="label" optionValue="value" [ngModel]="svc.barraBlocchi" (ngModelChange)="svc.impostaBarraBlocchi($event)" appendTo="body" [style]="{ width: '100%' }">
						<ng-template #selectedItem let-o>{{ o?.label | translate }}</ng-template>
						<ng-template #item let-o>{{ o.label | translate }}</ng-template>
					</p-select>
				</div>
			</div>
			}
			<small class="med-imp-nota"><i class="pi pi-info-circle"></i> {{ 'Le impostazioni valgono per tutti gli utenti dell\'azienda e si applicano con Salva; la posizione si vede subito.' | translate }}</small>
		</aside>
	}

	<!-- Barra degli strumenti: a sinistra cosa si modifica, in mezzo gli strumenti, a destra impostazioni / esci / salva -->
	<div #strumenti class="med-strumenti" role="toolbar" [class.med-chiede]="svc.confermaUscita() || svc.confermaRaggiungibili()" [attr.aria-label]="'Modifica menu' | translate">
		<div class="med-tb-zona med-strumenti-titolo">
			<i class="pi pi-pencil"></i>
			<span>{{ 'Modifica menu' | translate }}</span>
			@if (svc.nomeProfilo) {
				<span class="med-profilo">{{ svc.nomeProfilo }}</span>
			}
			@if (svc.modificato) {
				<span class="med-non-salvato"><span class="med-pallino"></span>{{ 'non salvato' | translate }}</span>
			}
			<button type="button" class="med-act med-aiuto" [pTooltip]="aiuto | translate" tooltipPosition="top" [attr.aria-label]="'Come si usa' | translate"><i class="pi pi-question-circle"></i></button>
		</div>

		@if (svc.confermaRaggiungibili()) {
			<div class="med-tb-zona med-tb-domanda" role="alert">
				<span class="med-conferma"><i class="pi pi-exclamation-triangle"></i> {{ svc.pagineIrraggiungibili().length }} {{ 'pagine non si raggiungeranno dal menu. Salvare comunque?' | translate }}</span>
				<p-button size="small" [outlined]="true" severity="secondary" [label]="'Rivedi' | translate" (onClick)="svc.confermaRaggiungibili.set(false); avvisiAperti = true"></p-button>
				<p-button size="small" severity="warn" icon="pi pi-save" [label]="'Salva comunque' | translate" [loading]="svc.salvataggio()" (onClick)="svc.salva(true)"></p-button>
			</div>
		} @else if (svc.confermaUscita()) {
			<!-- uscita con modifiche: come in Word, Salva / Non salvare / Annulla -->
			<div class="med-tb-zona med-tb-domanda" role="alert">
				<span class="med-conferma"><i class="pi pi-exclamation-circle"></i> {{ 'Salvare le modifiche al menu?' | translate }}</span>
				<p-button size="small" [text]="true" severity="secondary" [label]="'Annulla' | translate" (onClick)="svc.confermaUscita.set(false)"></p-button>
				<p-button size="small" [outlined]="true" severity="secondary" [label]="'Non salvare' | translate" (onClick)="esci()"></p-button>
				<p-button size="small" severity="primary" icon="pi pi-save" [label]="'Salva' | translate" [loading]="svc.salvataggio()" (onClick)="svc.salva()"></p-button>
			</div>
		} @else {
			<div class="med-tb-zona">
				<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-undo" [disabled]="!svc.puoAnnullare()" [pTooltip]="'Annulla ultima modifica (Ctrl+Z)' | translate" tooltipPosition="top" [ariaLabel]="'Annulla ultima modifica' | translate" (onClick)="svc.annullaUltima()"></p-button>
				<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-plus" [label]="'Nuovo gruppo' | translate" (onClick)="nuovoMenu()"></p-button>
				<p-button size="small" [outlined]="!paletteAperta" severity="secondary" icon="pi pi-link" [label]="'Collegamenti' | translate" [pTooltip]="'Pagine nascoste, cruscotti e collegamenti da trascinare nel menu' | translate" tooltipPosition="top" (onClick)="paletteAperta = !paletteAperta; riposiziona()"></p-button>
				<span class="med-sep"></span>
				@if (!svc.senzaRuoli) {
					<p-select [options]="opzioniRuolo" optionLabel="label" optionValue="value" [(ngModel)]="svc.ruolo" [filter]="svc.ruoli.length > 8" appendTo="body" [style]="{ width: '180px' }" [ariaLabel]="'Vedi come' | translate" [pTooltip]="'Vedi il menu come lo vede un ruolo' | translate" tooltipPosition="top">
						<ng-template #selectedItem let-o><i class="pi pi-eye med-vedi"></i> {{ o?.label }}</ng-template>
					</p-select>
				}
				<p-button size="small" [outlined]="true" severity="secondary" icon="pi pi-sitemap" [label]="'Mappa' | translate" [pTooltip]="'Vista ad albero del menu per il ruolo scelto, da stampare' | translate" tooltipPosition="top" (onClick)="apriMappa()"></p-button>
				@if (svc.pagineIrraggiungibili().length; as quante) {
					<p-button size="small" [outlined]="!avvisiAperti" severity="warn" icon="pi pi-exclamation-triangle" [label]="quante + ' ' + ((quante === 1 ? 'pagina non raggiungibile' : 'pagine non raggiungibili') | translate)" [pTooltip]="'Pagine dell\'azienda che con questo menu non si raggiungono' | translate" tooltipPosition="top" (onClick)="avvisiAperti = !avvisiAperti"></p-button>
				}
				@if (svc.appiattito) {
					<i class="pi pi-info-circle med-appiattito" [pTooltip]="'Questo menu aveva gruppi oltre il terzo livello: le loro voci sono state portate nel sottogruppo che li conteneva.' | translate" tooltipPosition="top"></i>
				}
			</div>
			<div class="med-tb-zona med-tb-dx">
				<p-button size="small" [outlined]="!impostazioniAperte" severity="secondary" icon="pi pi-cog" [label]="'Impostazioni' | translate" [pTooltip]="'Menu dell\'azienda, posizione e aspetto, esporta e importa' | translate" tooltipPosition="top" (onClick)="impostazioniAperte = !impostazioniAperte"></p-button>
				<span class="med-sep"></span>
				<p-button size="small" [outlined]="true" severity="secondary" [label]="'Esci' | translate" (onClick)="esci()"></p-button>
				<p-button size="small" severity="primary" icon="pi pi-save" [label]="'Salva' | translate" [loading]="svc.salvataggio()" (onClick)="svc.salva()"></p-button>
			</div>
		}
	</div>
</div>
